// 协议类型
// user: 用户协议, privacy: 隐私协议
export enum ProtocolType {
  User = "user", // 《全球语言服务平台用户服务协议》
  Privacy = "privacy", // 《全球语言服务平台隐私政策》
  ChildrenPrivacy = "children-privacy" // 《儿童隐私保护声明》
}

// 协议类型数组
export const protocolType: ProtocolType[] = [
  ProtocolType.User,
  ProtocolType.Privacy,
  ProtocolType.ChildrenPrivacy
];

// 协议路径
export const protocolPath = protocolType.map(type => {
  return {
    params: {
      query: type
    }
  };
});
